<div>
  <div class="top-row">
    <div class="top-body">
      @for (listItem of topList; track listItem) {
        <div [id]="identifierService.listitemId('figmaBucketlist', 'topItem_' + listItem?.acctId)" class="top-option bucketlist-option" [attr.value]="stringify(listItem)" (click)="setTopSelected($event)">
          @if (!customerTypeDirect && listItem?.mainLocation) {
            <span [id]="identifierService.labelId('figmaBucketlist', 'topLocation_' + listItem?.acctId)">
              {{ listItem?.mainLocation }}:</span
              >
            }
            {{ listItem?.lastName }},
            {{ listItem?.firstName }}
            @if (listItem?.middleName) {
              <span [id]="identifierService.labelId('figmaBucketlist', 'topMiddleName_' + listItem?.acctId)">
                {{ listItem?.middleName }}
              </span>
            }
            @if (listItem?.credentialsCd) {
              <span [id]="identifierService.labelId('figmaBucketlist', 'topCredentials_' + listItem?.acctId)">
                {{ listItem?.credentialsCd }}</span
                >
              }
            </div>
          }
        </div>
        <div class="top-side-bar">
          <div class="arrow-text-box" (click)="onAddButtonClick()">
            <mat-icon
              aria-hidden="false"
              aria-label="Example home icon"
              style="color: #03a9f4 !important"
              >arrow_downward</mat-icon
              >
              <div [id]="identifierService.labelId('figmaBucketlist', 'add')" class="arrow-text-box-text">
                {{ labels['label.gb.add'] }}
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-row" style="margin-top: 10px">
          <div class="bot-body">
            @for (listItem of botList; track listItem; let i = $index) {
              <div
                [id]="identifierService.listitemId('figmaBucketlist', 'botItem_' + listItem?.acctId)"
                class="bot-option bucketlist-option"
                [ngClass]="
                    implantselectedItem === listItem?.acctId
                        ? 'select-item'
                        : ''
                "
                [attr.value]="stringify(listItem)"
                (click)="setBotSelected($event, listItem)"
                >
                @if (enableNumbering) {
                  <span [id]="identifierService.labelId('figmaBucketlist', 'botNumber_' + listItem?.acctId)" class="sNoArea"
                    >{{ i + 1 }}.&nbsp;</span
                    >
                    }@if (!customerTypeDirect && listItem?.mainLocation) {
                    <span [id]="identifierService.labelId('figmaBucketlist', 'botLocation_' + listItem?.acctId)">
                      {{ listItem?.mainLocation }}:</span
                      >
                    }
                    {{((listItem?.lastName == "label.gb.oncall_physician") ? (listItem?.lastName | translate) : (listItem?.lastName))}},
                    {{ listItem?.firstName }}
                    @if (listItem?.middleName) {
                      <span [id]="identifierService.labelId('figmaBucketlist', 'botMiddleName_' + listItem?.acctId)">
                        {{ listItem?.middleName }}
                      </span>
                    }
                    @if (listItem?.credentialsCd) {
                      <span [id]="identifierService.labelId('figmaBucketlist', 'botCredentials_' + listItem?.acctId)">
                        {{ listItem?.credentialsCd }}</span
                        >
                      }
                    </div>
                  }
                </div>
                <div class="bot-side-bar">
                  <div class="arrow-text-box" (click)="onRemoveButtonClick()">
                    <mat-icon
                      aria-hidden="false"
                      aria-label="Example home icon"
                      style="color: #03a9f4 !important"
                      >arrow_upward</mat-icon
                      >
                      <div [id]="identifierService.labelId('figmaBucketlist', 'remove')" class="arrow-text-box-text">
                        {{ labels['label.gb.remove'] }}
                      </div>
                    </div>
                    <div style="margin-top: 10px">
                      <button
                        mat-mini-fab
                        color="primary"
                        class="sort-button"
                        (click)="onUpSortClick()"
                    [id]="
                        identifierService.dropdownId(
                            'figma-bucketlist',
                            'upSort'
                        )
                    "
                        >
                        <mat-icon
                          aria-hidden="false"
                          aria-label="Example home icon"
                          style="color: #03a9f4 !important"
                          >keyboard_arrow_up</mat-icon
                          >
                        </button>
                      </div>
                      <div style="margin-top: 10px">
                        <button
                          mat-mini-fab
                          color="primary"
                          class="sort-button"
                          (click)="onDownSortClick()"
                    [id]="
                        identifierService.dropdownId(
                            'figma-bucketlist',
                            'downSort'
                        )
                    "
                          >
                          <mat-icon
                            aria-hidden="false"
                            aria-label="Example home icon"
                            style="color: #03a9f4 !important"
                            >keyboard_arrow_down</mat-icon
                            >
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
